import { HttpClient } from '@angular/common/http';
import { forwardRef, Inject, Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, take } from 'rxjs';
import { AfmLog } from 'src/app/shared/models/afm-logs';
import { UserSettingsService } from '../user-settings/user-settings.service';

@Injectable({
  providedIn: 'root',
})
export class AfmLogsService {
  private url: string = environment.afmApis.topItems.baseUrl;

  constructor(
    private http: HttpClient,
    private injector: Injector
  ) {}

  private get userSettingsService(): UserSettingsService {
    return this.injector.get(UserSettingsService);
  }

  private sendLog(afmLog: AfmLog): Observable<any> {
    const endpoint = `${this.url}/afmlogs/`;
    return this.http.post(endpoint, afmLog);
  }

  private log(logCategory: string, logDescription: string): void {
    if (!this.userSettingsService.isLoggedIn) {
      return;
    }
    const afmLog: AfmLog = {
      logCategory: logCategory,
      logPage: window.location.href,
      logDescription: logDescription,
      server: this.userSettingsService.getUserServer(),
      language: this.userSettingsService.getUserLanguage().id,
    };
    this.sendLog(afmLog)
      .pipe(take(1))
      .subscribe({
        next: (response) => {},
        error: (error) => {
          console.error('Error sending log:', error);
        },
      });
  }

  logSiteUse(logDescription: string): void {
    this.log('site_use', logDescription);
  }

  logAccountInfo(logDescription: string): void {
    this.log('account_info', logDescription);
  }
}
